import { useEffect, useState, createContext, useContext } from "react";
// firebase
import { auth } from "utils/firebase";
// components
import LoadingPage from "components/Fallback/LoadingPage";

const AuthReadyContext = createContext();

export const useAuthReady = () => {
  const context = useContext(AuthReadyContext);
  if (!context) return { authInProgress: true };
  return context;
};

const FirebaseWrapper = ({ children }) => {
  const [authInProgress, setAuthInProgress] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      setAuthInProgress(true);

      if (user) {
        try {
          // Ensure token is fresh before marking as ready
          const token = await user.getIdToken(true);
          localStorage.setItem("firebaseToken", token);
        } catch (error) {
          // do nothing
        }
      }

      setAuthInProgress(false);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  if (authInProgress === true) {
    return (
      <div className="App" style={{ minHeight: window.innerHeight }}>
        <LoadingPage />
      </div>
    );
  }

  return (
    <AuthReadyContext.Provider value={{ authInProgress }}>
      {children}
    </AuthReadyContext.Provider>
  );
};

export default FirebaseWrapper;
